import { Component, ChangeDetectionStrategy, type OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { APP_NAME } from './shared/constants/app.constants';
import { AppLoaderComponent, ToastContainerComponent } from '@my-sport-app/cdk';
import { PushRegistrationService } from './core/services/push-registration.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppLoaderComponent, ToastContainerComponent],
  template: `
    <div id="app">
      <router-outlet></router-outlet>
    </div>
    <lib-loader message="Cargando..."></lib-loader>
    <lib-toast-container />
  `,
  changeDetection: ChangeDetectionStrategy.Default,
  styles: [`
    #app {
      min-height: 100vh;
    }
  `]
})
export class AppComponent implements OnInit {
  title = APP_NAME;
  private readonly router = inject(Router);
  private readonly pushRegistration = inject(PushRegistrationService);

  ngOnInit(): void {
    App.addListener('appUrlOpen', (event: { url: string }) => {
      const url = new URL(event.url);
      if (url.pathname.startsWith('/payments/confirmation/')) {
        this.router.navigateByUrl(url.pathname + url.search);
      }
    });

    if (Capacitor.isNativePlatform()) {
      this.pushRegistration.register().subscribe({
        error: (err) => console.warn('Push registration failed:', err?.friendlyMessage ?? err),
      });
    }
  }
}
